import {createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import {accountService} from "api";

export interface State {
  data: any;
  loading: boolean;
  error: string;
}

const initialState: State = {
  data: [],
  loading: false,
  error: "",
};

export const getAccounts = createAsyncThunk("account/getAccounts", async () => {
  const response = await accountService.getUsers();
  // console.log("🚀 ~ file: account.ts:18 ~ getAccounts ~ response:", response.data)
  return response.data;
});

export const getRoleApi = createAsyncThunk(
  "account/getRoleApi",
  async (id: number) => {
    const response = await accountService.getRoleApi(id);
    return response.data;
  }
);

export const accountSlice = createSlice({
  name: "account",
  initialState: initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      // xu ly action dang nhap
    },
  },
  extraReducers(builder) {
    builder.addCase(getRoleApi.pending, (state, action) => {
      if (!state.loading) {
        state.loading = true;
      }
    });
    builder.addCase(getRoleApi.fulfilled, (state, action) => {
      if (state.loading) {
        state.data = action.payload;
        state.loading = false;
      }
    });
    builder.addCase(getRoleApi.rejected, (state, action) => {
      if (state.loading) {
        state.loading = false;
        // state.error = action.error.;
      }
    });
  },
});

export const {login} = accountSlice.actions;

export default accountSlice.reducer;
